"use strict";

module.exports = {
    "copyright": {
        "link": "ООО «<i18n:param>content</i18n:param>»",
        "yandex": "Яндекс"
    }
};